import { render } from "./PdfCheckbox.vue?vue&type=template&id=1920f023&scoped=true"
import script from "./PdfCheckbox.vue?vue&type=script&lang=js"
export * from "./PdfCheckbox.vue?vue&type=script&lang=js"

import "./PdfCheckbox.vue?vue&type=style&index=0&id=1920f023&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1920f023"]])

export default __exports__